import { Link } from 'react-router-dom';
import { useI18n } from '../i18n';

export default function Landing() {
  const { t } = useI18n();
  return (
    <div className="max-w-6xl mx-auto px-4 pt-12 pb-24">
      <section className="grid md:grid-cols-2 gap-12 items-center">
        <div className="text-center md:text-left">
          <div className="mp-eyebrow">{t('landing.eyebrow')}</div>
          <h1 className="mp-display text-5xl md:text-6xl text-tarot-gold mt-4 leading-[1.05]">
            {t('landing.title_a')}<br />{t('landing.title_b')}
          </h1>
          <p className="mt-6 text-tarot-muted leading-relaxed max-w-md mx-auto md:mx-0 whitespace-pre-line">
            {t('landing.sub')}
          </p>
          <div className="mt-10 flex flex-wrap justify-center md:justify-start gap-3">
            <Link to="/login" className="btn-primary">{t('landing.cta_start')}</Link>
            <Link to="/pricing" className="btn-ghost">{t('landing.cta_pricing')}</Link>
          </div>
          <p className="mt-5 text-sm text-tarot-muted">{t('landing.cta_note')}</p>
        </div>

        <div className="mp-hero-cards" aria-hidden="true">
          <div className="mp-hero-glow" />
          <div className="mp-hero-card a">✦</div>
          <div className="mp-hero-card b">☾</div>
          <div className="mp-hero-card c">◆</div>
        </div>
      </section>

      <section className="mt-28 text-center">
        <div className="mp-eyebrow">{t('landing.omen_eyebrow')}</div>
        <h2 className="mp-display text-3xl md:text-4xl text-tarot-gold mt-3">
          {t('landing.omen_title')}
        </h2>
        <p className="mt-4 text-tarot-muted max-w-xl mx-auto leading-relaxed">
          {t('landing.omen_sub')}
        </p>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-4 max-w-4xl mx-auto">
          {VERDICTS.map((v) => (
            <div key={v.key} className="card text-center" style={{ borderColor: `${v.color}55` }}>
              <div className="mp-display text-3xl" style={{ color: v.color }}>
                {t(`verdict.${v.key}` as any)}
              </div>
              <div className="text-tarot-muted text-sm mt-2 tracking-widest">
                {t(`verdict.${v.key}_cn` as any)} · {'★'.repeat(v.stars)}
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="mt-28">
        <div className="text-center mb-12">
          <div className="mp-eyebrow">{t('landing.mentors_eyebrow')}</div>
          <h2 className="mp-display text-3xl md:text-4xl text-tarot-gold mt-3">
            {t('landing.mentors_title')}
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          <Feature glyph="✦" tone="#E0AF68" title={t('landing.feature_a_title')} body={t('landing.feature_a_body')} />
          <Feature glyph="☾" tone="#C9A4D9" title={t('landing.feature_b_title')} body={t('landing.feature_b_body')} />
          <Feature glyph="◆" tone="#9BD8E8" title={t('landing.feature_c_title')} body={t('landing.feature_c_body')} />
        </div>

        <div className="mt-14 text-center">
          <Link to="/login" className="btn-primary">{t('landing.cta_today')}</Link>
        </div>
      </section>
    </div>
  );
}

const VERDICTS: { key: 'super_lucky' | 'lucky' | 'trust' | 'caution'; stars: number; color: string }[] = [
  { key: 'super_lucky', stars: 5, color: '#E0AF68' },
  { key: 'lucky', stars: 4, color: '#9BD8E8' },
  { key: 'trust', stars: 3, color: '#C9A4D9' },
  { key: 'caution', stars: 2, color: '#9690B5' },
];

function Feature({ glyph, tone, title, body }: { glyph: string; tone: string; title: string; body: string }) {
  return (
    <div className="card">
      <div className="mp-display text-4xl mb-3" style={{ color: tone }} aria-hidden="true">
        {glyph}
      </div>
      <h3 className="text-tarot-gold text-lg mb-2">{title}</h3>
      <p className="text-tarot-muted text-sm leading-relaxed">{body}</p>
    </div>
  );
}
